import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Col, Row, Layout, Spin,
} from 'antd';
import { getLeadProfileRequest } from '../redux/actions/get_lead_profile.actions';
import LeadProfileHeader from './Lead_profile_table/LeadProfileHeader';
import LeadProfileInfo from './Lead_profile_table/LeadProfileInfo';
import LeadProfileTable from './Lead_profile_table/LeadProfileTable';
import CustomerNotes from './Lead_profile_table/CustomerNotes';
import ApprovalInfo from './Lead_profile_table/ApprovalInfo';
import CustomerRemarks from './Lead_profile_table/CustomerRemarks';
import BikeUpgrades from './Lead_profile_table/BikeUpgrades';

class LeadProfileView extends Component {
    componentDidMount() {
        this.props.getLeadProfileRequest(this.props.location.pathname.split('/').pop());
    }

    render() {
        return (
            <Spin spinning={this.props.loading} tip="Loading Lead...">
                <Layout className="lead-profile-container">
                    <Col span={24}>
                        <LeadProfileHeader />
                        <Row gutter={16}>
                            <Col span={18}>
                                <LeadProfileTable />
                                {
                                    this.props.Leads && this.props.user_groups
                                    && (
                                        <LeadProfileInfo
                                            Leads={this.props.Leads}
                                            user_groups={this.props.user_groups}
                                        />
                                    )
                                }
                            </Col>
                            <Col span={6}>
                                <ApprovalInfo />
                                <CustomerNotes />
                                {
                                    this.props.loading
                                        ? ''
                                        : <BikeUpgrades />
                                }
                                {/* {
                                    this.props.loading
                                        ? ''
                                        : <CustomerRemarks />
                                } */}
                            </Col>
                        </Row>
                    </Col>
                </Layout>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.Leads.Lead_profile.Lead_general.loading,
    Leads: state.Leads,
    user_groups: state.App.App_content.user.groups,
});

export default connect(mapStateToProps, { getLeadProfileRequest })(LeadProfileView);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/index.js